// src/components/RouterErrorBoundary.tsx
import React from "react";
import { useRouteError } from "react-router-dom";

const RouterErrorBoundary: React.FC = () => {
  const error = useRouteError();
  const isDev = import.meta.env.MODE === "development";
  const stack = (error as Error)?.stack || "";
  const message = (error as Error)?.message || "알 수 없는 오류입니다";

  const stackLines = stack.split("\n");
  const sourceLine = stackLines.find((line) => line.includes("/src/"));

  return (
    <div style={{ padding: "2rem", backgroundColor: "#ffeeee" }}>
      <h2>🚨 에러 발생!</h2>
      <p>{message}</p>

      {isDev && sourceLine && (
        <pre style={{ color: "#aa0000", marginTop: "1rem" }}>
          📍 {sourceLine.trim()}
        </pre>
      )}

      {isDev && (
        <details style={{ marginTop: "1rem", whiteSpace: "pre-wrap" }}>
          <summary>🔍 전체 Stack Trace</summary>
          <pre>{stack}</pre>
        </details>
      )}
    </div>
  );
};

export default RouterErrorBoundary;
